import { usePageMeta } from "@/lib/usePageMeta";
import { useLang } from "@/lib/i18n";
import { LegalPage } from "@/components/LegalPage";

export default function Terms() {
  const { t } = useLang();
  usePageMeta(t.terms.meta);
  return <LegalPage data={t.terms} testId="terms" />;
}
